module.exports = __webpack_public_path__ + "20e318dd2.png";